import React from 'react';
import { useTranslation } from 'next-i18next';
import PdpProductFeed from '@components/product/pdp-product-feed/pdp-product-feed';
import useFeatureFlag from '@hooks/use-feature-flags';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { useSemPdpFeed } from '@hooks/product/use-sem-pdp-feed';
import { ProductFeedSource } from '@interfaces/api/payloads/product-feed-payload';
import useProductQuery from '@hooks/product/use-product-query';

const SemPdpSimilarProductsFeed = () => {
  const { product } = useProductQuery();
  const { t } = useTranslation();
  const productFeedCategory = 'sem_pdp_recommend';
  const { isSemPDP } = useFeatureFlag();
  const { sendAnalyticEvent } = useAnalyticEvents('similar_products');
  const feedType = 'similar_products';

  const productID = parseInt(product.id, 10);

  const semPdpFeed = useSemPdpFeed({
    productID: productID,
    source: isSemPDP ? ProductFeedSource.SEMPDP : ProductFeedSource.PDP,
  });

  if (semPdpFeed.items.length === 0) {
    return null;
  }

  return (
    <div>
      <PdpProductFeed
        products={semPdpFeed.items}
        productFeedCategory={productFeedCategory}
        title={t('HERO_PDP.SIMILAR_PRODUCT.TITLE')}
        productCardProps={{
          moduleType: 'similar_products',
          pageType: 'product_page',
          // options for small tiles
          cardType: isSemPDP ? 'standard' : 'small',
          disableLikeButton: !isSemPDP,
          displayElements: {
            productLocation: isSemPDP,
            productTags: isSemPDP,
          },
        }}
        cta={{
          title: t('PRODUCT.DISCOVER.CTA'),
          sendClickAnalytics: () => sendAnalyticEvent('pdp_reco_view_all', { label: feedType }),
          href: `/similar-products?productId=${productID}&feedType=${feedType}`,
          rel: 'nofollow',
        }}
        testId={`sem_similar_products`}
        disableOnReveal
      />
    </div>
  );
};

export default SemPdpSimilarProductsFeed;
